export const required = function(label)  {
  return (value) => {
    return !!value || (label || '') + ' ' + this.$t("APP.REQUIRED")
  }
}
